var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hoistingHotWork" },
    [
      _vm._l(_vm.hoistings, function (item) {
        return _c(
          "Collapse",
          {
            key: item.id,
            ref: "hoistingDetail_collapse_" + item.id,
            refInFor: true,
            staticClass: "hoistingDetail_collapse",
            attrs: { hoistingData: item, keepContentAlive: true },
          },
          [
            _c("CollapseTitleSlot", {
              attrs: {
                slot: "title",
                id: item.id,
                permitData: item,
                title: _vm.hoistingLabel,
                showStatus: false,
                dotOption: _vm.dotOption,
                showDot: _vm.showDot(item),
              },
              slot: "title",
            }),
            _vm._v(" "),
            _c("HoistingDetail", {
              key: item.id,
              ref: "HoistingDetail_" + item.id,
              refInFor: true,
              attrs: {
                slot: "content",
                hoistingData: item,
                isEdit: _vm.isEdit,
                floorsOptions: _vm.floorsOptions,
                isProjectAvailable: _vm.isProjectAvailable,
              },
              slot: "content",
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.showHoistingTab && !_vm.disableContractorEdit
        ? [
            _vm.isEdit
              ? _c(
                  "div",
                  {
                    staticClass: "addNewHoisting",
                    on: { click: _vm._addNewHoisting },
                  },
                  [_vm._v("\n      " + _vm._s(_vm.addHoistingLabel) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "workPermit_hint" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "termsAndConditions." +
                        _vm.regionName +
                        ".workPermit.hintForEdinburghTower",
                      [_vm.hoistingLabel, 5]
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "workPermit_hint" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "termsAndConditions." +
                        _vm.regionName +
                        ".workPermit.hintForOthers",
                      [_vm.hoistingLabel, 3]
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "workPermit_hint" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "termsAndConditions." +
                        _vm.regionName +
                        ".workPermit.hintForPermitNumberLimit",
                      [
                        _vm.maxWAPPRHoistingNum,
                        _vm.standalone
                          ? _vm.$t("workPermit.HoistingLimitHintType.work")
                          : _vm.$t("workPermit.HoistingLimitHintType.project"),
                        _vm.hoistingLabel,
                      ]
                    )
                  ) +
                  "\n    "
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteConfirmModal",
        attrs: {
          modalId: _vm.delConfModalId,
          confirmTitle: _vm.hoistingConfirmHint,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }